var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 38C42.9728 38 47.7419 36.0246 51.2583 32.5083C54.7746 28.9919 56.75 24.2228 56.75 19.25C56.75 14.2772 54.7746 9.50806 51.2583 5.99175C47.7419 2.47544 42.9728 0.5 38 0.5C33.0272 0.5 28.2581 2.47544 24.7417 5.99175C21.2254 9.50806 19.25 14.2772 19.25 19.25C19.25 24.2228 21.2254 28.9919 24.7417 32.5083C28.2581 36.0246 33.0272 38 38 38ZM50.5 19.25C50.5 22.5652 49.183 25.7446 46.8388 28.0888C44.4946 30.433 41.3152 31.75 38 31.75C34.6848 31.75 31.5054 30.433 29.1612 28.0888C26.817 25.7446 25.5 22.5652 25.5 19.25C25.5 15.9348 26.817 12.7554 29.1612 10.4112C31.5054 8.06696 34.6848 6.75 38 6.75C41.3152 6.75 44.4946 8.06696 46.8388 10.4112C49.183 12.7554 50.5 15.9348 50.5 19.25ZM75.5 69.25C75.5 75.5 69.25 75.5 69.25 75.5H6.75C6.75 75.5 0.5 75.5 0.5 69.25C0.5 63 6.75 44.25 38 44.25C69.25 44.25 75.5 63 75.5 69.25ZM69.25 69.225C69.2437 67.6875 68.2875 63.0625 64.05 58.825C59.975 54.75 52.3063 50.5 38 50.5C23.6937 50.5 16.025 54.75 11.95 58.825C7.7125 63.0625 6.7625 67.6875 6.75 69.225H69.25Z",
    fill: "#98A6AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1f3aa332d4aef1f91929a1e290fee592.svg";
export { ForwardRef as ReactComponent };